import React from "react";

// Create context from language
export const LanguageContext = React.createContext();
